import React, { ReactElement } from 'react';
import * as app from "../services/AppService";

function AccordionItem({ children, title, disabled, show }: { children: ReactElement | ReactElement[] | any, title: string, disabled: boolean, show: boolean }) {
    return (

        <div className="accordion-item ">
            <h2 className="accordion-header border-bottom" id="headingOne">
                <button style={{ "height": "35px" }} className={`accordion-button color-danger fw-bold ${disabled ? "opacity-50" : ""}`} type="button" data-bs-toggle="collapse" data-bs-target={`#${title}`} aria-expanded="true" aria-controls="collapseOne" disabled={disabled}>
                    {app.translate(title)}
                </button>
            </h2>
            <div id={title} className={`accordion-collapse collapse  ${show ? "show" : ""}`} aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                    {children}
                </div>
            </div>
        </div>

    );
}

AccordionItem.defaultProps = {
    class: " ",
    disabled: false,
    show: false
}
export default AccordionItem;